import i18next, { TFunction } from "i18next";
import { ActivityV1Type } from "../types";

export interface ActivityTypeDefinition {
  key: ActivityV1Type;
  titleI18nKey: string;
  descriptionI18nKey: string;
}

export const ACTIVITY_TYPES: ActivityTypeDefinition[] = [
  {
    key: "DA_SCORM",
    titleI18nKey: "types.scorm.title",
    descriptionI18nKey: "types.scorm.description",
  },
  {
    key: "DA_EXTERNAL_RES",
    titleI18nKey: "types.brightcove.title",
    descriptionI18nKey: "types.brightcove.description",
  },
  {
    key: "DA_XAPI",
    titleI18nKey: "types.xapi.title",
    descriptionI18nKey: "types.xapi.description",
  },
  {
    key: "DA_VIRTUAL_CLASS",
    titleI18nKey: "types.virtual-class.title",
    descriptionI18nKey: "types.virtual-class.description",
  },
  {
    key: "DA_PHYSICAL_CLASS",
    titleI18nKey: "types.physical-class.title",
    descriptionI18nKey: "types.physical-class.description",
  },
  {
    key: "DA_URL_RES",
    titleI18nKey: "types.url-res.title",
    descriptionI18nKey: "types.url-res.description",
  },
  {
    key: "DA_SURVEY",
    titleI18nKey: "types.survey.title",
    descriptionI18nKey: "types.survey.description",
  },
  {
    key: "DA_YOUTUBE",
    titleI18nKey: "types.youtube.title",
    descriptionI18nKey: "types.youtube.description",
  },
  {
    key: "DA_LINKEDIN",
    titleI18nKey: "types.linkedin.title",
    descriptionI18nKey: "types.linkedin.description",
  },
  {
    key: "DA_LTI",
    titleI18nKey: "types.lti.title",
    descriptionI18nKey: "types.lti.description",
  },
];

const ACTIVITY_TYPE_BY_KEY: Record<string, ActivityTypeDefinition> =
  ACTIVITY_TYPES.reduce(
    (acc, td) => {
      acc[td.key] = td;
      return acc;
    },
    {} as Record<string, ActivityTypeDefinition>,
  );

const AGGREGATED_ACTIVITY_TYPE = "DIDACTICAL_ACTIVITY";

export const formatActivityTypeLabel = (
  rawType: string | undefined | null,
  tActivity?: TFunction,
): string => {
  if (!rawType) return "";
  const translate = tActivity ?? i18next.getFixedT(null, "wizard-activity");
  if (rawType === AGGREGATED_ACTIVITY_TYPE) {
    return String(translate("types.generic.title", { defaultValue: rawType }));
  }
  const def = ACTIVITY_TYPE_BY_KEY[rawType];
  if (!def) return rawType;
  return String(translate(def.titleI18nKey, { defaultValue: rawType }));
};
